import React from 'react';
import { Button } from '../components/ui/button';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';
import { faqs, businessInfo } from '../data/mock';

const FAQ = () => {
  return (
    <div>
      {/* Hero */}
      <section className="bg-gradient-to-br from-slate-50 to-teal/5 py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <h1 className="text-4xl sm:text-5xl font-bold text-navy mb-6">
              Frequently Asked Questions
            </h1>
            <p className="text-xl text-slate-600 leading-relaxed">
              Got questions about bookkeeping? We've got answers. If you can't find what you're looking for, 
              feel free to get in touch—we're always happy to help.
            </p>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 lg:py-28 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq) => (
              <AccordionItem 
                key={faq.id} 
                value={`item-${faq.id}`}
                className="border border-slate-200 rounded-xl px-6 shadow-sm hover:shadow-md transition-shadow data-[state=open]:shadow-md data-[state=open]:border-teal/30"
              >
                <AccordionTrigger className="text-left py-6 hover:no-underline group">
                  <span className="text-lg font-semibold text-navy group-hover:text-teal transition-colors pr-4">
                    {faq.question}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-slate-600 leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

      {/* Still Have Questions */}
      <section className="py-20 lg:py-28 bg-slate-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl sm:text-4xl font-bold text-navy mb-6">
            Still Have Questions?
          </h2>
          <p className="text-lg text-slate-600 mb-8 max-w-2xl mx-auto">
            We're here to help. Whether you're curious about our services, pricing, or anything else, 
            don't hesitate to reach out. No question is too small.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href={`tel:${businessInfo.phone}`}>
              <Button size="lg" className="bg-amber hover:bg-amber-dark text-navy font-semibold px-8 h-14 text-lg w-full sm:w-auto">
                Call: {businessInfo.phone}
              </Button>
            </a>
            <a href={`mailto:${businessInfo.email}?subject=Bookkeeping%20Enquiry&body=Hello%20Wonderman%20Bookkeeping%2C%0A%0AI%20am%20interested%20in%20learning%20more%20about%20your%20bookkeeping%20services.%0A%0AName%3A%20%0ABusiness%20Name%3A%20%0APhone%3A%20%0A%0APlease%20get%20in%20touch%20at%20your%20earliest%20convenience.%0A%0AThank%20you.`}>
              <Button size="lg" variant="outline" className="border-2 border-teal text-teal hover:bg-teal hover:text-white px-8 h-14 text-lg w-full sm:w-auto">
                Send a Message
              </Button>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;
